import "./index.css";
import { useEffect, useState } from "react";
import {
  collection,
  collectionGroup,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
  setDoc,
} from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Papa from "papaparse";

function Trabalhos() {
  const [trabalhos, setTrabalhos] = useState([]);
  const [erro, setErro] = useState("");
  const [selecionado, setSelecionado] = useState(null);
  const [edit, setedit] = useState(false);
  const [pesquisa, setPesquisa] = useState("");
  const [uploading, setUploading] = useState(false);

  const [novo, setNovo] = useState({
    tipo: "",
    codigo_do_trabalho: "",
    codigo_unico: "",
    titulo: "",
    abstract: "",
    autores: "",
    co_autores: "",
    trabalho_autores: "",
    trabalho_co_autores: "",
    tema_principal: "",
    palavras_chaves: "",
  });

  const fetchTrabalhos = async () => {
    try {
      const snap = await getDocs(collectionGroup(db, "evento_trabalhos"));
      const all = snap.docs.map((d) => {
        const pathSegments = d.ref.path.split("/");
        const tipoId =
          pathSegments.length >= 3 ? pathSegments[pathSegments.length - 3] : d.data().tipo || "";
        return {
          id: d.id,
          tipo: tipoId,
          __refPathSegments: pathSegments,
          ...d.data(),
        };
      });
      setTrabalhos(all);
    } catch (err) {
      console.error("Erro ao carregar trabalhos:", err);
      setErro("Erro ao carregar os trabalhos.");
    }
  };

  useEffect(() => {
    fetchTrabalhos();
  }, []);

  const deletarTrabalho = async (trabalho) => {
    if (!window.confirm("Tem certeza de que deseja excluir este trabalho da app?")) return;
    try {
      const segs = trabalho.__refPathSegments;
      await deleteDoc(doc(db, ...segs));
      setTrabalhos((prev) => prev.filter((t) => t.id !== trabalho.id));
      if (selecionado?.id === trabalho.id) setSelecionado(null);
    } catch (err) {
      console.error(err);
      window.alert("Erro ao apagar o trabalho.");
    }
  };

  // ------------------------------------------------------------------
  //      IMPORTAÇÃO CSV SEMPARTIR CAMPOS COM VÍRGULAS
  // ------------------------------------------------------------------

  const handleImportarCSV = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    window.alert("A sua importação está em processamento. Por favor, aguarde...");

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        try {
          const data = results.data;

          if (!data.length) throw new Error();
          if (!("codigo_unico" in data[0]) || !("tipo" in data[0])) throw new Error();

          const existentes = new Set(
            trabalhos.map((t) => (t.codigo_unico || "").toLowerCase().trim())
          );

          let duplicados = [];
          let adicionados = 0;

          for (const obj of data) {
            const codigoLower = (obj.codigo_unico || "").toLowerCase().trim();
            if (!codigoLower) continue;

            if (existentes.has(codigoLower)) {
              duplicados.push(obj.codigo_unico);
            } else {
              const tipoId = obj.tipo?.trim() || "sem_tipo";
              const tipoRef = doc(db, "evento_trabalhos_filtro", tipoId);

              await setDoc(tipoRef, { tipo: tipoId }, { merge: true });
              await addDoc(collection(tipoRef, "evento_trabalhos"), obj);

              existentes.add(codigoLower);
              adicionados++;
            }
          }

          await fetchTrabalhos();

          if (adicionados === 0 && duplicados.length > 0) {
            window.alert("Todos os dados já estão inseridos na tabela");
          } else if (duplicados.length > 0) {
            window.alert(
              `A sua importação foi concluída parcialmente.
Foram inseridos ${adicionados} dados.
Valores duplicados: ${duplicados.join(", ")}`
            );
          } else {
            window.alert(`A sua importação foi concluída. Foram inseridos ${adicionados} dados.`);
          }
        } catch (err) {
          console.error(err);
          window.alert("A sua importação falhou. Verifique a estrutura do CSV.");
        }

        e.target.value = null;
      },
    });
  };

  // ------------------------------------------------------------------
  // EXPORTAÇÃO CSV
  // ------------------------------------------------------------------
  const exportarCSV = () => {
    const headers = [
      "tipo",
      "codigo_do_trabalho",
      "codigo_unico",
      "titulo",
      "tema_principal",
      "autores",
      "trabalho_autores",
      "co_autores",
      "trabalho_co_autores",
      "palavras_chaves",
      "abstract",
    ];

    const rows = trabalhos.length
      ? trabalhos.map((t) => headers.map((h) => t[h] || ""))
      : [headers.map(() => "")];

    const csv = [headers, ...rows].map((r) => r.map((v) => `"${v}"`).join(";")).join("\n");
    const bom = "\uFEFF";
    const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "trabalhos.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUploadPDF = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== "application/pdf") {
      window.alert("Apenas ficheiros PDF são permitidos.");
      return;
    }

    try {
      setUploading(true);
      const storageRef = ref(storage, `abstracts/${Date.now()}_${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      setNovo((prev) => ({ ...prev, abstract: url }));
      window.alert("O seu envio foi concluído com sucesso.");
    } catch (err) {
      console.error(err);
      window.alert("O seu envio falhou. Tente novamente.");
    } finally {
      setUploading(false);
    }
  };

  const guardarEdicao = async () => {
    if (!selecionado) return;
    try {
      const segs = selecionado.__refPathSegments;
      await updateDoc(doc(db, ...segs), novo);
      await fetchTrabalhos();
      setedit(false);
      setSelecionado(null);
    } catch (err) {
      console.error(err);
      window.alert("Erro ao guardar o trabalho.");
    }
  };

  const trabalhosFiltrados = trabalhos.filter((t) =>
    t.titulo?.toLowerCase().includes(pesquisa.toLowerCase())
  );

  if (erro) return <p>{erro}</p>;

  return (
    <div className="table-container">
      <div className="filtros">
        <input
          type="text"
          placeholder="Procurar por título"
          value={pesquisa}
          onChange={(e) => setPesquisa(e.target.value)}
          className="input"
        />

        <button className="btn btn-other" onClick={exportarCSV}>
          Exportar CSV
        </button>

        <label className="btn btn-other">
          Importar CSV
          <input type="file" accept=".csv" style={{ display: "none" }} onChange={handleImportarCSV} />
        </label>
      </div>

      {trabalhosFiltrados.length === 0 ? (
        <p style={{ textAlign: "center", color: "#6b7280" }}>Sem dados</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Código</th>
              <th>Título</th>
              <th>Autores</th>
              <th>Tema</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {trabalhosFiltrados.map((item) => (
              <tr key={`${item.tipo}__${item.id}`}>
                <td>{item.tipo || "—"}</td>
                <td>{item.codigo_do_trabalho || "—"} / {item.codigo_unico || "—"}</td>
                <td>{item.titulo || "—"}</td>
                <td>{item.autores || "—"}</td>
                <td>{item.tema_principal || "—"}</td>
                <td>
                  <button
                    className="btn btn-add"
                    onClick={() => {
                      setSelecionado(item);
                      setedit(true);
                      const copy = { ...item };
                      delete copy.__refPathSegments;
                      setNovo(copy);
                    }}
                  >
                    Editar
                  </button>

                  <button className="btn btn-delete" onClick={() => deletarTrabalho(item)}>
                    Apagar
                  </button>

                  {item.abstract && (
                    <a
                      href={item.abstract}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-other"
                      style={{ marginLeft: "5px" }}
                    >
                      Ver
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selecionado && (
        <div className="drawer">

          <div className="drawer-content">
            <div>
              <label>Tipo:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.tipo || ""}
                  onChange={(e) => setNovo((prev) => ({ ...prev, tipo: e.target.value }))}
                />
              ) : (
                <span>{selecionado.tipo || "—"}</span>
              )}
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <div>
                <br></br><br></br><label>Código do Trabalho:</label>
                {edit ? (
                  <input
                    type="text"
                    value={novo.codigo_do_trabalho || ""}
                    onChange={(e) =>
                      setNovo((prev) => ({ ...prev, codigo_do_trabalho: e.target.value }))
                    }
                  />
                ) : (
                  <span>{selecionado.codigo_do_trabalho || "—"}</span>
                )}
              </div>

              <div>
                <br></br><br></br><label>Código Único:</label>
                {edit ? (
                  <input
                    type="text"
                    value={novo.codigo_unico || ""}
                    onChange={(e) =>
                      setNovo((prev) => ({ ...prev, codigo_unico: e.target.value }))
                    }
                  />
                ) : (
                  <span>{selecionado.codigo_unico || "—"}</span>
                )}
              </div>
            </div>

            <div>
              <br></br><br></br><label>Título:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.titulo || ""}
                  onChange={(e) => setNovo((prev) => ({ ...prev, titulo: e.target.value }))}
                />
              ) : (
                <span>{selecionado.titulo || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>Tema Principal:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.tema_principal || ""}
                  onChange={(e) =>
                    setNovo((prev) => ({ ...prev, tema_principal: e.target.value }))
                  }
                />
              ) : (
                <span>{selecionado.tema_principal || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>Autores:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.autores || ""}
                  onChange={(e) => setNovo((prev) => ({ ...prev, autores: e.target.value }))}
                />
              ) : (
                <span>{selecionado.autores || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>Trabalho Autores:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.trabalho_autores || ""}
                  onChange={(e) =>
                    setNovo((prev) => ({ ...prev, trabalho_autores: e.target.value }))
                  }
                />
              ) : (
                <span>{selecionado.trabalho_autores || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>Co-Autores:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.co_autores || ""}
                  onChange={(e) =>
                    setNovo((prev) => ({ ...prev, co_autores: e.target.value }))
                  }
                />
              ) : (
                <span>{selecionado.co_autores || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>Trabalho Co-Autores:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.trabalho_co_autores || ""}
                  onChange={(e) =>
                    setNovo((prev) => ({ ...prev, trabalho_co_autores: e.target.value }))
                  }
                />
              ) : (
                <span>{selecionado.trabalho_co_autores || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>Palavras-Chaves:</label>
              {edit ? (
                <input
                  type="text"
                  value={novo.palavras_chaves || ""}
                  onChange={(e) =>
                    setNovo((prev) => ({ ...prev, palavras_chaves: e.target.value }))
                  }
                />
              ) : (
                <span>{selecionado.palavras_chaves || "—"}</span>
              )}
            </div>

            <div>
              <br></br><br></br><label>PDF:</label>
              {edit ? (
                <>
                  {novo.abstract ? (
                    <p><a href={novo.abstract} target="_blank" rel="noreferrer">Ver PDF</a></p>
                  ) : (
                    <p>Nenhum PDF enviado</p>
                  )}
                  <input type="file" accept="application/pdf" onChange={handleUploadPDF} disabled={uploading} />
                  {uploading && <p>A enviar ficheiro...</p>}
                </>
              ) : novo.abstract ? (
                <a href={novo.abstract} target="_blank" rel="noreferrer">Ver PDF</a>
              ) : (
                <span>—</span>
              )}
            </div>
          </div>

          <div className="drawer-footer">
            {edit ? (
              <>
                <button className="btn btn-add" onClick={guardarEdicao}>
                  Guardar
                </button>
                <button className="btn btn-cancel" onClick={() => { setedit(false); setSelecionado(null); }}>
                  Cancelar
                </button>
              </>
            ) : (
              <button className="btn btn-add" onClick={() => setedit(true)}>
                Editar
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Trabalhos;
